import React, { useState } from "react";
import "../styles/depositLocker.css";
import { getVacantLockers } from "../Utility/utility";
import VacantLockerTable from "./VacantLockerTable";

const DepositLocker = () => {
  const [searchType, setSearchType] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [searchClicked, setSearchClicked] = useState(0);
  const [isSearchTypeOpen, setIsSearchTypeOpen] =
    useState(false);

  const searchOptions = [
    {
      value: "branchCode",
      label: "Branch Code",
    },
    {
      value: "branchName",
      label: "Branch Name",
    },
    {
      value: "postalCode",
      label: "Pin Code",
    },
  ];

  const handleSearch = async () => {
    // STQC Validation
    if (!searchType) {
      alert("Please select search category");
      return;
    }

    if (!searchValue.trim()) {
      alert("Please enter Branch Code, Branch Name or Pin Code");
      return;
    }

    setSearchClicked((prev) => prev + 1);

    try {
      const items = await getVacantLockers(
        searchType,
        searchValue
      );

      console.log(
        "Vacant Lockers Items:",
        items?.[0]
      );
    } catch (error) {
      console.log(
        "Error fetching vacant lockers:",
        error.message
      );
    }
  };

  return (
    <div className="locker-wrapper">
      {/* HEADING */}
      <div className="locker-title-row">
        <a
          href="/documents/d/guest/annex-for-ai1-feature-2707202307"
          target="_blank"
          rel="noreferrer"
          className="locker-title"
          aria-label="Download PDF for ONLINE BLOCKING OF SAFE DEPOSIT LOCKER (270.85 KB)"
        >
          ONLINE BLOCKING OF SAFE DEPOSIT LOCKER{" "}
          <span
            className="locker-pdf"
            aria-hidden="true"
          >
            📄 (pdf - 270.85 KB)
          </span>
        </a>
      </div>

      {/* SEARCH SECTION */}
      <div className="locker-search-row">
        {/* Search Category */}
        <div className="atm-field">
          <label id="locker-search-label" htmlFor="locker-search-type">
            Select search category{" "}
            <span
              style={{ color: "#B30000" }}
              aria-hidden="true"
            >
              *
            </span>
            <span className="sr-only"> (required)</span>
          </label>

          <div className="locker-combobox">
            <button
              id="locker-search-type"
              type="button"
              role="combobox"
              className="locker-select"
              aria-labelledby="locker-search-label"
              aria-expanded={isSearchTypeOpen}
              aria-controls="locker-search-options"
              aria-haspopup="listbox"
              aria-required="true"
              onClick={() =>
                setIsSearchTypeOpen((prev) => !prev)
              }
            >
              {searchType
                ? searchOptions.find(
                  (option) => option.value === searchType
                )?.label
                : "Please select search category"}

              <span
                className="locker-select-arrow"
                aria-hidden="true"
              />
            </button>

            {isSearchTypeOpen && (
              <ul
                id="locker-search-options"
                className="locker-options"
                role="listbox"
                aria-labelledby="locker-search-label"
              >
                {searchOptions.map((option, index) => (
                  <li
                    key={option.value}
                    id={`locker-option-${option.value}`}
                    role="option"
                    aria-selected={searchType === option.value}
                    aria-posinset={index + 1}
                    aria-setsize={searchOptions.length}
                    tabIndex={0}
                    className={
                      searchType === option.value
                        ? "locker-option selected"
                        : "locker-option"
                    }
                    onClick={() => {
                      setSearchType(option.value);
                      setIsSearchTypeOpen(false);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();

                        setSearchType(option.value);
                        setIsSearchTypeOpen(false);
                      }
                    }}
                  >
                    {option.label}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {/* Search Value */}
        <div className="atm-field">
          <label htmlFor="locker-search-input">
            Enter Branch Code, Branch Name,
            or Pin Code
          </label>

          <input
            id="locker-search-input"
            type="text"
            className="locker-input"
            placeholder="Enter Branch Code/ Branch Name/ Pin Code"
            value={searchValue}
            onChange={(e) =>
              setSearchValue(e.target.value)
            }
          />
        </div>

        <button
          type="button"
          className="locker-search-btn"
          onClick={handleSearch}
          aria-label="Search locker availability"
          aria-controls="locker-results"
        >
          Search
        </button>
      </div>

      {/* RESULTS TABLE */}
      <VacantLockerTable
        searchType={searchType}
        searchValue={searchValue}
        searchClicked={searchClicked}
      />
    </div>
  );
};

export default DepositLocker;